import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { I18nProvider } from './i18n';

// Service Worker per PWA (opzionale)
// import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);

// Registra service worker per PWA
// serviceWorkerRegistration.register();

// Web Vitals per performance monitoring
// import reportWebVitals from './reportWebVitals';
// reportWebVitals(console.log);
